import { createFileRoute } from "@tanstack/react-router";
import { setPageTitle } from "@/components/app-shell/app-shell";
import { NotificationForm } from "@/components/notifications/notification-form";
import { authorizeFeatures } from "@/lib/authorize-feature";

export const Route = createFileRoute("/_app/account/notifications/new")({
  beforeLoad: () => setPageTitle("New Notification"),
  loader: async ({ context }) =>
    authorizeFeatures(context, ["policy_evaluator"]),
  component: NewNotificationPage,
});

function NewNotificationPage() {
  return (
    <div className="flex w-full flex-col gap-4 p-6">
      <div className="flex min-h-[38px] items-center justify-between">
        <h1 className="text-2xl dark:font-light">New Notification</h1>
      </div>
      <div className="border-stroke-line border-b" />
      <NotificationForm />
    </div>
  );
}
